import { inject, provide, ref } from 'vue'
import { FeedFormatKey } from '@/api/types'
import { IFeedFormatAttributes } from '@/apps/traforama/interfaces/feedFormats'
import { useFeedFormatsStore } from '@/apps/traforama/store/feedFormats'

const useFetchFeedFormat = () => {
  const feedFormatsStore = useFeedFormatsStore()

  const feedFormat = ref<IFeedFormatAttributes | undefined>(undefined)
  const fetchingFeedFormat = ref(true)

  function FetchItem(id: string, skipId?: boolean): void {
    feedFormatsStore.FetchItem(id).then(() => {
      const storedItem = feedFormatsStore.itemById(id)
      fetchingFeedFormat.value = false
      if (storedItem !== undefined && storedItem !== null) {
        if (skipId) {
          delete storedItem['id']
          feedFormat.value = { ...storedItem } as IFeedFormatAttributes
        } else {
          feedFormat.value = storedItem as IFeedFormatAttributes
        }
      }
    })
  }

  const provideFeedFormat = function () {
    provide(FeedFormatKey, feedFormat)
    return feedFormat
  }

  const injectFeedFormat = function () {
    return inject(FeedFormatKey)
  }

  return {
    feedFormat,
    fetchingFeedFormat,
    FetchItem,
    provideFeedFormat,
    injectFeedFormat
  }
}

export default useFetchFeedFormat
